import { createAPI } from '../../common'

export default {
  preAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0f60bdujpot0qsfbdujpo', 'post', config, {
      neverLoading: true
    }),
  postAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0f60bdujpot0qptubdujpo', 'get', config, {
      neverLoading: true
    }),
  // 稿件送审
  postRootArticlesTransfer: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bsujdmft0qspd0usbotgfs', 'post', config),

  // 审核通过
  postArticlePass: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bsujdmft0qspd0qbtt', 'post', config),
  // 校对完成
  postArticleProof: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bsujdmft0qspd0qsppg', 'post', config),
  // 稿件驳回
  postArticleReject: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bsujdmft0qspd0sfkfdu', 'post', config),
  // 稿件发布
  postArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bsujdmft0qspd0qvcmjti', 'post', config, {
      timeout: 90000
    }),
  // 稿件签发（暂无 但是视频号和其他稿库不同 签发和发布是两个接口
  postArticlesPublish: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bsujdmft0qspd0jttvf', 'post', config),
  // 获取发布状态
  getArticlesPublishStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bsujdmft0qvcmjtiTubuvt', 'GET', config),

  // 媒体号-详情页操作权限
  getArticlesActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0f60bdujpot0efubjmbdujpot', 'get', config),

  // 稿件详情
  getArticlesDetails: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bsujdmft0efubjm', 'GET', config),
  // 修改痕迹 - 所有
  getAllArticlesTraces: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0wfstjpo0usbdf0bmm', 'get', config),
  // 获取不同用户修改痕迹
  getArticlesTracesByDifUser: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0wfstjpo0usbdf0vtfst0bmufsobuf',
      'get',
      config,
      vconfig
    ),
  // 获取不同用户修改痕迹(新)
  getArticlesTracesByDifUserNew: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0wfstjpo0usbdf0vtfst0bmufsobuf0ofx',
      'get',
      config,
      vconfig
    ),
  // 根据指定用户获取修改痕迹 - 未使用
  getArticlesTracesBySameUser: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0wfstjpo0usbdf0vtfst0tbnf', 'get', config),
  // 根据选择版本获取修改痕迹
  getArticlesTracesByVersion: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0wfstjpo0usbdf0wfstjpot0tfmfdu',
      'get',
      config,
      vconfig
    ),
}
